import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Garrett Guillotte --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "SignalFx ingestion";
const frontMatter = {
  "title": "SignalFx ingestion"
};
export function useTOC(props) {
  return [{
    value: "Configure SignalFx ingestion",
    id: "configure-signalfx-ingestion",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"SignalFx ingestion"}</_components.h1>{"\n"}<_components.p>{"You can configure the Collector to process SignalFx data points. The Collector serves\nSignalFx traffic at the "}<_components.code>{"/signalfx/v2/datapoint"}</_components.code>{" HTTP endpoint from the\n"}<_components.code>{"listenAddress"}</_components.code>{", which defaults to "}<_components.code>{"0.0.0.0:3030"}</_components.code>{". The "}<_components.code>{"/v2/datapoint"}</_components.code>{" suffix is the\ndefault expected path appended by SignalFx client libraries."}</_components.p>{"\n"}<_components.p>{"This integration pattern assumes that you’ve instrumented your apps with a SignalFx\nclient library, such as the "}<_components.a href="https://github.com/signalfx/golib">{"golib"}</_components.a>{" library for\nGo."}</_components.p>{"\n"}<_components.p>{"For equivalent functions between SignalFx and PromQL, see the\n"}<_components.a href="/ingest/metrics-traces/collector/mappings/signalfx">{"equivalent function list"}</_components.a>{"."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.ol>{"\n"}<_components.li>{"\n"}<_components.p>{"Download this\n"}<_components.a href="https://storage.googleapis.com/chronosphere-release/latest/kubernetes/chronocollector.yaml">{"annotated manifest"}</_components.a>{"\nas a starting point."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Enable SignalFx mode under the "}<_components.code>{"push.signalFX.enabled"}</_components.code>{" YAML collection in the\nCollector manifest."}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="yaml" data-word-wrap=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"push"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"   signalFX"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-light": "#D32F2F"
  }}>{"      enabled"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{":"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" true"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Modify additional configuration options under the "}<_components.code>{"push.signalFX"}</_components.code>{" YAML collection."}</_components.p>{"\n"}</_components.li>{"\n"}</_components.ol></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/ingest/metrics-traces/collector/addl-metrics/signalfx',
  {"filePath":"pages/ingest/metrics-traces/collector/addl-metrics/signalfx.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)